import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import '@templates/pursuitLeader/forecast/styles/styles.css';
import {
  MotifIcon,
  MotifTooltip,
  MotifTextLink,
  MotifButton,
  MotifTruncate,
} from '@ey-xd/motif-react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { LicenseManager } from 'ag-grid-enterprise';
import { AG_GRID_LICENSE_KEY } from '@constants/licenseKeys';
import { actionIcInfo24px } from '@ey-xd/motif-react/assets/icons';

import {
  EmptyForcastContainer,
  EmptyForcastText,
  CellWarningError,
  CellWarningErrorBlack,
  TableData1A,
  TableData1B,
  TableData1C,
  PLTableContainer,
  OppsListContainer,
  OppsContainer,
  OppsItemContainer,
  ToggleContainer,
  ItemTextContainer,
  ItemTovValueContainer,
  ItemLinkText,
  ItemDetailsText,
  PursuitTypeCell,
} from '@atoms/tableData/styles/tableData.styles';
import PursuitLeaderToggle from '@templates/pursuitLeader/forecast/tableComponent/pursuitLeaderToggle';
import {
  getOpportunitiesDetails,
  getQuaterlyDetails,
  submitPlOpportunity,
} from '@services/pursuitLeaderServices';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  PL_Commit_State,
  Pl_Opps_Details_Modal_State,
  Pl_Comment_Modal_State,
  Quaterly_OP_Details_State,
  Recoil_Quarter_State,
  Current_User,
  Pl_Submit_Success_Modal_State,
  Pl_Failure_Modal_State,
  PursuitLeaderTableRowDataState,
  System_Date_Time_State,
  Operating_System_State,
  Trigger_Update_Pl_Sidebar_Data,
  Pl_Sidebar_Update_Opp_Payload,
  Refresh_Pl_Sidebar_Data,
  Is_Baddata_Available,
  Refresh_Pl_Forecast_page,
  Full_Page_Loading_State,
  Is_Opps_Bad_Data_Available_State,
  Submission_Failure,
} from '@recoil/recoil';
import {
  RemoveTimeStamp,
  formatNumberWithKAndM,
  trimAndAddDots,
  formatAWDDate,
  adjustOffsetToTimeZone,
  hasSystemTimePassed,
} from '@util/commonUtil';
import PlOpportunityNameModal from '@organisms/modals/plOpportunityNameModal';
import TableHeader from '@molecules/gcsp/components/tableHeader';
import PlCommentModal from '@organisms/modals/plCommentModal';
import {
  filterOpportunityById,
  retainCommitAndModifyOpportunity,
  QuaterlyDetailsChangeKeys,
  isBadDataAvailable,
  logError,
} from '@util/commonFunctions';
import chat_outline from '@assets/icons/chat_outline.png';
import { OPERATING_SYSTEM, SOURCE } from '@constants/commonConstants';
import { isMobile, isTablet } from 'react-device-detect';
import { columnDefs } from '@templates/pursuitLeader/forecast/tableComponent/plColumnDefs';
import { appInsights } from '@services/appInsightsService';
LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY);

let gridApi;
let PlOppsIframeUrl;
let CommentIframeUrl;
let PlMobileOppsIframeUrl;
let MobileCommentIframeUrl;
const screenWidth = window.innerWidth;

const PursuitLeaderTable = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [totalPageRows, setTotalPageRows] = useState(null);
  const [rowData, setRowData] = useRecoilState(PursuitLeaderTableRowDataState);
  const [plCommitData, setPlCommitData] = useRecoilState(PL_Commit_State);
  const setPlQuaterlyDetails = useSetRecoilState(Quaterly_OP_Details_State);
  const quarterData = useRecoilValue(Recoil_Quarter_State);
  const [showPlIframeModalRecoil, setPlIframeModalRecoil] = useRecoilState(
    Pl_Opps_Details_Modal_State,
  );
  const setShowSubmitConfirmationModal = useSetRecoilState(Pl_Submit_Success_Modal_State);
  const setShowFailureSubmitModal = useSetRecoilState(Pl_Failure_Modal_State);
  const [showCommentIframeModalRecoil, setCommentIframeModalRecoil] = //eslint-disable-line
    useRecoilState(Pl_Comment_Modal_State);
  const triggerUpdatePlSidebarData = useRecoilValue(Trigger_Update_Pl_Sidebar_Data);
  const setCommitStatusUpdateOpportunity = useSetRecoilState(Pl_Sidebar_Update_Opp_Payload);
  const refreshPlForecastPage = useRecoilValue(Refresh_Pl_Forecast_page);
  const currentUser = useRecoilValue(Current_User);
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  const osInfo = useRecoilValue(Operating_System_State);
  const [refreshPLSidebarData, setRefreshPLSidebarData] = useRecoilState(Refresh_Pl_Sidebar_Data); //eslint-disable-line
  const setIsBaddataFound = useSetRecoilState(Is_Baddata_Available);
  const [pageInnerHeight, setPageInnerHeight] = useState(window.innerWidth);
  const setIsFullPageLoading = useSetRecoilState(Full_Page_Loading_State);
  const [opportunitiesLoaded, setOpportunitiesLoaded] = useState(false); // eslint-disable-line
  const setIsOppsBadDataAvailable = useSetRecoilState(Is_Opps_Bad_Data_Available_State);
  const setShowSubmissionFailureModal = useSetRecoilState(Submission_Failure);
  const [selectedOpportunityId, setSelectedOpportunityId] = useState(null); // Add this state
  const [selectedCommentOpportunityId, setSelectedCommentOpportunityId] = useState(null); // Add this state for comments

  const TodaysDate = systemDateTime ? new Date(systemDateTime) : new Date();
  const personaStartDateCheck = quarterData ? new Date(quarterData.persona_startdate) : new Date();
  const personaCloseDateCheck = quarterData ? new Date(quarterData.persona_closedate) : new Date();
  let IsSubmitDisabled = false;
  IsSubmitDisabled =
    !(TodaysDate >= personaStartDateCheck && TodaysDate <= personaCloseDateCheck) ||
    (localStorage.getItem('isSuperUser') == 'true' &&
      localStorage.getItem('targetUserEmail') !== 'null')
      ? true // Disable
      : false; // Enable

  let rowDataArray;

  const isSystemTimePassed = hasSystemTimePassed(personaCloseDateCheck);
  appInsights.trackTrace({
    message: JSON.stringify({
      message: `Value of hasSystemTimePassed response for PL: ${isSystemTimePassed}`,
      userId: localStorage.getItem('userEmail'),
      source: SOURCE.FRONTEND,
    }),
    severityLevel: 1, // 1 represents response log
  });

  useEffect(() => {
    if (isSystemTimePassed) {
      /* Removing rowData from session storage to handle the scenario where the user changes the commit toggle but leaves the browser tab open and the forecast window gets closed. In this case, the retain commit logic should not be triggered. */
      sessionStorage.removeItem('rowData');
    }
    if (quarterData !== null) {
      const fetchData = async () => {
        setIsLoading(true);
        setIsFullPageLoading(true);
        appInsights.trackTrace({
          message: JSON.stringify({
            message: `Calling getOpportunitiesDetails for PL: ${currentUser.email}, ${TodaysDate}`,
            userId: localStorage.getItem('userEmail'),
            source: SOURCE.FRONTEND,
          }),
          severityLevel: 1, // 1 represents response log
        });
        try {
          const getOpportunitiesDetailsAPI = await getOpportunitiesDetails(
            currentUser.email,
            TodaysDate,
          );
          rowDataArray = getOpportunitiesDetailsAPI?.opportunities;
          setIsOppsBadDataAvailable(getOpportunitiesDetailsAPI?.isBadDataAvailable);
          const badDataStatus = await isBadDataAvailable(rowDataArray);
          setIsBaddataFound(badDataStatus);

          if (sessionStorage.getItem('rowData')) {
            setTimeout(async () => {
              const oldRowDataArray = JSON.parse(sessionStorage.getItem('rowData'));
              const getOpportunitiesDetailsAPI = await getOpportunitiesDetails(
                currentUser.email,
                TodaysDate,
              );
              const newOpportunites = getOpportunitiesDetailsAPI?.opportunities;
              const badDataStatus = await isBadDataAvailable(newOpportunites);
              setIsBaddataFound(badDataStatus);

              appInsights.trackTrace({
                message: JSON.stringify({
                  message: `Setting sessionstorage's CrmUpdatedOpportunities as: ${JSON.stringify(newOpportunites)}`,
                  userId: localStorage.getItem('userEmail'),
                  source: SOURCE.FRONTEND,
                }),
                severityLevel: 1, // 1 represents response log
              });
              sessionStorage.setItem('CrmUpdatedOpportunities', JSON.stringify(newOpportunites));

              const updateOpportunites = await retainCommitAndModifyOpportunity(
                oldRowDataArray,
                newOpportunites,
              );

              appInsights.trackTrace({
                message: JSON.stringify({
                  message: `updateOpportunites after  retainCommitAndModifyOpportunity for PL: ${updateOpportunites}`,
                  userId: localStorage.getItem('userEmail'),
                  source: SOURCE.FRONTEND,
                }),
                severityLevel: 1, // 1 represents response log
              });

              // sessionStorage.setItem('rowData', JSON.stringify(updateOpportunites));
              setRowData(updateOpportunites);
              setRefreshPLSidebarData(true);
            }, 3000);
          } else {
            sessionStorage.setItem('CrmUpdatedOpportunities', JSON.stringify(rowDataArray));
            setRowData(getOpportunitiesDetailsAPI?.opportunities);
            sessionStorage.setItem(
              'rowData',
              JSON.stringify(getOpportunitiesDetailsAPI?.opportunities),
            );
            setRefreshPLSidebarData(true);
          }

          appInsights.trackTrace({
            message: JSON.stringify({
              message: `Calling getCrmQuaterlyOpportunities with ${JSON.stringify(rowDataArray)}`,
              userId: localStorage.getItem('userEmail'),
              source: SOURCE.FRONTEND,
            }),
            severityLevel: 1, // 1 represents response log
          });

          const newPlQuaterlyDetails = await getCrmQuaterlyOpportunities(rowDataArray);
          appInsights.trackTrace({
            message: JSON.stringify({
              message: `Response of getCrmQuaterlyOpportunities with ${JSON.stringify(newPlQuaterlyDetails)}`,
              userId: localStorage.getItem('userEmail'),
              source: SOURCE.FRONTEND,
            }),
            severityLevel: 1, // 1 represents response log
          });
          setPlQuaterlyDetails(newPlQuaterlyDetails);

          setTimeout(() => {
            const availableTableHeight = document.getElementById('container')?.clientHeight;
            const rowCount = availableTableHeight && calculatePageSize(availableTableHeight);
            setTotalPageRows(rowCount);
          }, 500);
        } catch (error) {
          logError('getOpportunitiesDetails / getCrmQuaterlyOpportunities', error);
        } finally {
          const timeoutId = setTimeout(() => {
            setIsLoading(false);
          }, 3000);
          return () => clearTimeout(timeoutId); // eslint-disable-line
        }
      };
      fetchData();
    }
  }, [quarterData, refreshPlForecastPage]);

  useEffect(async () => {
    if (
      !!sessionStorage.getItem('CrmUpdatedOpportunities') &&
      rowData !== 0 &&
      quarterData !== null
    ) {
      const updatedCommitStatusList = rowData;
      const NonUpdatedCommitStatusList = JSON.parse(
        sessionStorage.getItem('CrmUpdatedOpportunities'),
      );
      appInsights.trackTrace({
        message: JSON.stringify({
          message: `Calling getCrmQuaterlyOpportunities inside useEffect of triggerUpdatePlSidebarData ${JSON.stringify(updatedCommitStatusList)}`,
          userId: localStorage.getItem('userEmail'),
          source: SOURCE.FRONTEND,
        }),
        severityLevel: 1, // 1 represents response log
      });
      const newPlQuaterlyDetails = await getCrmQuaterlyOpportunities(updatedCommitStatusList);
      appInsights.trackTrace({
        message: JSON.stringify({
          message: `Response of getCrmQuaterlyOpportunities inside useEffect of triggerUpdatePlSidebarData ${JSON.stringify(newPlQuaterlyDetails)}`,
          userId: localStorage.getItem('userEmail'),
          source: SOURCE.FRONTEND,
        }),
        severityLevel: 1, // 1 represents response log
      });
      setPlQuaterlyDetails(newPlQuaterlyDetails);
      appInsights.trackTrace({
        message: JSON.stringify({
          message: `Response of QuaterlyDetailsChangeKeys inside useEffect of triggerUpdatePlSidebarData ${JSON.stringify(newPlQuaterlyDetails)}`,
          userId: localStorage.getItem('userEmail'),
          source: SOURCE.FRONTEND,
        }),
        severityLevel: 1, // 1 represents response log
      });
      const crm_quaterly_response = await QuaterlyDetailsChangeKeys(newPlQuaterlyDetails);
      appInsights.trackTrace({
        message: JSON.stringify({
          message: `Response of getCrmQuaterlyOpportunities inside useEffect of triggerUpdatePlSidebarData ${JSON.stringify(crm_quaterly_response)}`,
          userId: localStorage.getItem('userEmail'),
          source: SOURCE.FRONTEND,
        }),
        severityLevel: 1, // 1 represents response log
      });
      sessionStorage.setItem('rowData', JSON.stringify(updatedCommitStatusList));

      updatedCommitStatusList.forEach(newObj => {
        const oldObj = NonUpdatedCommitStatusList.find(oldObj => oldObj.opp_id === newObj.opp_id);

        if (oldObj && oldObj.commit_status !== newObj.commit_status) {
          setToggleChange(newObj.commit_status, newObj.opportunity_id, crm_quaterly_response);

          // To send modified opportunity details to update sidebar
          const opportunityUpdatePayload = {
            toggleStatus: newObj.commit_status,
            opp_id: newObj.opp_id,
            tov: newObj.tov,
            awd: newObj.awd,
            awd_period: newObj.awd_period,
            fiscal_year: newObj.fiscal_year,
            month: newObj.month,
          };

          setCommitStatusUpdateOpportunity(opportunityUpdatePayload);
        }
      });

      sessionStorage.removeItem('CrmUpdatedOpportunities');
    }
  }, [triggerUpdatePlSidebarData]);

  useEffect(() => {
    // Added this to re-update recoil to get fresh data for next use.
    const savedRowData = sessionStorage.getItem('rowData');
    if (savedRowData) {
      setRowData(JSON.parse(savedRowData));
    }
  }, [plCommitData]);

  useEffect(() => {
    const handleResize = () => {
      setPageInnerHeight(window.innerHeight);
      if (document.getElementById('container')) {
        const availableTableHeight = document.getElementById('container')?.clientHeight;
        const rowCount = availableTableHeight && calculatePageSize(availableTableHeight);
        setTotalPageRows(rowCount);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [pageInnerHeight]);

  const getCrmQuaterlyOpportunities = async rowOpportunityData => {
    const QUATER_START_DATE = quarterData ? RemoveTimeStamp(quarterData.quarter_start_date) : '';
    const QUATER_END_DATE = quarterData ? RemoveTimeStamp(quarterData.quarter_end_date) : '';

    const getQuaterlyDetailsAPI = await getQuaterlyDetails(
      currentUser.email,
      QUATER_START_DATE,
      QUATER_END_DATE,
    );

    const newPlQuaterlyDetails = await filterOpportunityById(
      getQuaterlyDetailsAPI.CRM_Response,
      rowOpportunityData,
    );
    // setPlQuaterlyDetails(newPlQuaterlyDetails);
    return newPlQuaterlyDetails;
  };

  const calculatePageSize = tableHeight => {
    const screenHeight = window.innerHeight;
    const singleRowHeight = 43; //(in Pixel)
    const noOfRowsToBeRemoved = osInfo === OPERATING_SYSTEM.MAC ? 1 : 2;
    const minusFactor = screenHeight <= 720 ? noOfRowsToBeRemoved : noOfRowsToBeRemoved + 1;
    const totalRows = Math.floor(tableHeight / singleRowHeight) - minusFactor;
    return JSON.stringify(totalRows);
  };

  const handleGridReady = params => {
    ({ api: gridApi } = params);
  };

  const TextCellRendererA = ({ value }) => <TableData1A>{value}</TableData1A>;

  TextCellRendererA.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const TextCellRendererB = ({ value }) => <TableData1B>{value}</TableData1B>;
  TextCellRendererB.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const TextCellRendererC = ({ value }) => (
    <TableData1C>
      <MotifTooltip
        id="bottom"
        trigger={trimAndAddDots(value)}
        allowHover={true}
        allowClick={true}
        placement="bottom"
      >
        {value}
      </MotifTooltip>
    </TableData1C>
  );
  TextCellRendererB.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const TextCellRendererE = ({ value }) => (
    <TableData1C>
      <MotifTruncate maxWidth={140}>
        {value || <span style={{ color: 'red' }}> ----</span>}
      </MotifTruncate>
    </TableData1C>
  );
  TextCellRendererE.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const PursuitTypeCellRenderer = ({ value }) => {
    // Convert pursuit types to uppercase(Brand New) for display
    const displayValue = value
      ? value
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      : '';

    return <PursuitTypeCell>{displayValue}</PursuitTypeCell>;
  };
  PursuitTypeCellRenderer.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const TextCellRendererD = ({ value }) => {
    // For addign '$' Sign to TOV value
    const formattedValue = Number(value).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    return <TableData1C>{formattedValue}</TableData1C>;
  };
  TextCellRendererD.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const AWD_Field_Rendere = props => {
    const { awd, month } = props;

    let awdTimeStamp = awd;
    let MonthStartDateCheck = quarterData
      ? new Date(quarterData.current_month_start_date)
      : new Date(systemDateTime);
    let TodaysDate = localStorage.getItem('modifiedSystemDateAndTime')
      ? new Date(localStorage.getItem('modifiedSystemDateAndTime'))
      : new Date();

    awdTimeStamp = adjustOffsetToTimeZone(awd);
    awdTimeStamp = new Date(
      awdTimeStamp.getFullYear(),
      awdTimeStamp.getMonth(),
      awdTimeStamp.getDate(),
    );

    MonthStartDateCheck = new Date(MonthStartDateCheck.toISOString().split('T')[0]);
    MonthStartDateCheck = new Date(
      MonthStartDateCheck.getFullYear(),
      MonthStartDateCheck.getMonth(),
      MonthStartDateCheck.getDate(),
    );

    TodaysDate = new Date(TodaysDate.getFullYear(), TodaysDate.getMonth(), TodaysDate.getDate());

    // Black Color : If awd is less than month start date AND awd is greater or equal to today's date
    if (awdTimeStamp < MonthStartDateCheck && awdTimeStamp >= TodaysDate) {
      return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <MotifTooltip
            id="bottom"
            trigger={<MotifIcon src={actionIcInfo24px} className="CellWarningErrorBlack" />}
            allowHover={true}
            allowClick={true}
            placement="bottom"
            hideCloseButton={true}
          >
            This AWD is in the past month. <br />
            You will need to update the AWD <br />
            in the Opportunity before changing <br />
            the commit status.
          </MotifTooltip>

          <CellWarningErrorBlack>{`${formatAWDDate(awd)} (${month})`}</CellWarningErrorBlack>
        </div>
      );
    }
    // Red Color : If awd is less than today's date
    if (awdTimeStamp < TodaysDate) {
      return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <MotifTooltip
            id="bottom"
            trigger={<MotifIcon src={actionIcInfo24px} className="CellWarningError" />}
            allowHover={true}
            allowClick={true}
            placement="bottom"
            hideCloseButton={true}
          >
            Opportunities must have a <br />
            future Anticipated Win Date <br />
            (AWD) before a forecast can be <br />
            submitted. Please update the <br />
            AWD or mark it as a decline or <br />
            lost through the opportunity <br />
            name hyperlink or by visiting <br /> EY CRM.
          </MotifTooltip>

          <CellWarningError>{`${formatAWDDate(awd)} (${month})`}</CellWarningError>
        </div>
      );
    }
    return <TableData1C>{`${formatAWDDate(awd)} (${month})`}</TableData1C>;
  };
  AWD_Field_Rendere.propTypes = {
    value: PropTypes.string.isRequired, // eslint-disable-line
  };

  const TextLinkRenderer = props => {
    const { value, opportunity_id, ey_id } = props;

    return (
      <div style={{ alignSelf: 'center', display: 'flex', alignItems: 'center' }}>
        <TableData1A>
          {ey_id === undefined || ey_id === null || ey_id === '' ? (
            <MotifTextLink
              variant="alt"
              style={{ textDecoration: 'none' }}
              href="#"
              onClick={() => {
                onOpportunityNameClick(opportunity_id);
              }}
            >
              <MotifTooltip
                id="bottom"
                trigger={
                  <MotifIcon
                    src={actionIcInfo24px}
                    className="CellWarningError"
                    style={{ color: '#b9251c' }}
                  />
                }
                allowHover={true}
                allowClick={true}
                hideCloseButton={true}
                placement="bottom"
              >
                Opportunities can only be <br /> committed or included in the <br /> forecast
                submission if they <br />
                have a valid ID. Please refresh
                <br />
                the page and try again, or
                <br />
                contact the support team for <br />
                assistance.
              </MotifTooltip>
              {value}
            </MotifTextLink>
          ) : (
            <MotifTextLink
              variant="alt"
              style={{ textDecoration: 'none' }}
              href="#"
              onClick={() => {
                onOpportunityNameClick(opportunity_id);
              }}
            >
              {value}
            </MotifTextLink>
          )}
        </TableData1A>
      </div>
    );
  };
  // );
  TextLinkRenderer.propTypes = {
    value: PropTypes.string.isRequired, // eslint-disable-line
  };

  let crm_update = [];

  const setToggleChange = (commit_status, opportunity_id, crm_quaterly_response) => {
    let predata = rowData.map(item => ({
      commit_status: item.commit_status,
      opportunity_id: item.opportunity_id,
    }));

    predata = predata.filter(
      item => item.opportunity_id === opportunity_id && item.commit_status === commit_status,
    );

    if (opportunity_id) {
      const crm_obj = {
        commit_status: commit_status,
        opportunity_id: opportunity_id,
      };

      crm_update = crm_update.filter(item => item.opportunity_id !== opportunity_id);

      if (predata.length === 0) {
        crm_update.push(crm_obj);
      }

      // Added for commit retain functionality
      if (predata.length !== 0 && !!sessionStorage.getItem('CrmUpdatedOpportunities')) {
        crm_update.push(crm_obj);
      }

      setPlCommitData({
        forecast_table_details: {
          forecast_id: currentUser.email,
        },
        crm_update: [...crm_update],
        crm_quaterly_response: crm_quaterly_response,
      });
    } else if (crm_update.length !== 0 && (opportunity_id !== null || opportunity_id !== '')) {
      // If commit_status is false, removing the obj based on opportunity_id
      crm_update = crm_update.filter(item => item.opportunity_id !== opportunity_id);

      setPlCommitData({
        forecast_table_details: {
          forecast_id: currentUser.email,
        },
        crm_update: [...crm_update],
        crm_quaterly_response: crm_quaterly_response,
      });
    }

    modifyOpportunityDetails(commit_status, opportunity_id);
  };

  const modifyOpportunityDetails = (commit_status, opportunity_id) => {
    const savedRowData = sessionStorage.getItem('rowData');
    const updatedRowData = JSON.parse(savedRowData).map(item => {
      if (item.opp_id === opportunity_id) {
        return { ...item, commit_status: commit_status };
      }
      return item;
    });
    sessionStorage.setItem('rowData', JSON.stringify(updatedRowData));
    setRowData(updatedRowData);
  };

  const ToggleSwicthRenderer = props => {
    const {
      value,
      opportunity_id,
      tov,
      awd,
      awd_period,
      month,
      fiscal_year,
      ey_id,
      commit_status,
    } = props;

    let isDisabled = false;
    let awdTimeStamp = awd;
    const blankOppId = ey_id;
    let MonthStartDateCheck = quarterData
      ? new Date(quarterData.current_month_start_date)
      : new Date(systemDateTime);
    // If modifiedSystemDateAndTime is not available in localStorage then use systemDateTime
    let TodaysDate = localStorage.getItem('modifiedSystemDateAndTime')
      ? new Date(localStorage.getItem('modifiedSystemDateAndTime'))
      : new Date(systemDateTime);
    // systemDateTime ? new Date(systemDateTime) : new Date();

    awdTimeStamp = adjustOffsetToTimeZone(awd);
    awdTimeStamp = new Date(
      awdTimeStamp.getFullYear(),
      awdTimeStamp.getMonth(),
      awdTimeStamp.getDate(),
    );

    MonthStartDateCheck = new Date(MonthStartDateCheck.toISOString().split('T')[0]);
    MonthStartDateCheck = new Date(
      MonthStartDateCheck.getFullYear(),
      MonthStartDateCheck.getMonth(),
      MonthStartDateCheck.getDate(),
    );

    TodaysDate = new Date(TodaysDate.getFullYear(), TodaysDate.getMonth(), TodaysDate.getDate());

    //commit toggle status for awd check with month start date and current day's date
    if (awdTimeStamp < MonthStartDateCheck || awdTimeStamp < TodaysDate) {
      isDisabled = true;
    }

    //check for commit toggle on blank opp_id
    if (blankOppId === undefined || blankOppId === null || blankOppId === '') {
      isDisabled = true;
    }

    if (
      localStorage.getItem('isSuperUser') == 'true' &&
      localStorage.getItem('targetUserEmail') !== 'null'
    ) {
      isDisabled = true; // Disable toggle for super user
    }

    return (
      <PursuitLeaderToggle
        toggleStatus={(isMobile || isTablet) && screenWidth < 1170 ? commit_status : value}
        opp_id={opportunity_id}
        tov={tov}
        awd={awd}
        awd_period={awd_period}
        month={month}
        fiscal_year={fiscal_year}
        onToggleChange={(commit_status, crm_quaterly_response) => {
          setToggleChange(commit_status, opportunity_id, crm_quaterly_response);
        }}
        isDisabled={isDisabled}
      />
    );
  };
  ToggleSwicthRenderer.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const handleCommitLink = opp_id => {
    onCommentIconClick(opp_id);
  };

  const CommentColumnRenderer = ({ value, data }) => (
    <div style={{ alignSelf: 'center', display: 'flex', alignItems: 'center' }}>
      <TableData1A>
        <MotifTextLink variant="alt" href="#" onClick={() => handleCommitLink(data.opp_id)}>
          {value}
          <span style={{ margin: '3px' }}> </span>
          <img src={chat_outline} alt="Comment link" className="CustomChatIcon" />
        </MotifTextLink>
      </TableData1A>
    </div>
  );

  const rowClassRules = useMemo(() => {
    return {
      'toggle-checked-row': params => params.data.commit_status === true,
    };
  }, []);

  const onOpportunityNameClick = id => {
    if (
      localStorage.getItem('isSuperUser') == 'true' &&
      localStorage.getItem('targetUserEmail') != 'null'
    ) {
      // Set flag to use userEmail for iframe operations in super user mode
      localStorage.setItem('isIframeOperation', 'true');
      PlOppsIframeUrl = `${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_OPP_NAME_URL_APP_ID}&navbar=off&forceUCI=1&pagetype=entityrecord&etn=opportunity&id=${id}&formid=${process.env.REACT_APP_OPP_NAME_URL_FORM_ID}`;
      PlMobileOppsIframeUrl = `${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_MOBILE_OPP_NAME_URL_APP_ID}&navbar=off&forceUCI=1&pagetype=entityrecord&etn=opportunity&id=${id}&formid=${process.env.REACT_APP_OPP_NAME_URL_FORM_ID}`;
      setSelectedOpportunityId(id); // to store the id
      setPlIframeModalRecoil(true);
    } else {
      // Regular user operation
      localStorage.setItem('isIframeOperation', 'false');
      PlOppsIframeUrl = `${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_OPP_NAME_URL_APP_ID}&navbar=off&forceUCI=1&pagetype=entityrecord&etn=opportunity&id=${id}&formid=${process.env.REACT_APP_OPP_NAME_URL_FORM_ID}`;
      PlMobileOppsIframeUrl = `${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_MOBILE_OPP_NAME_URL_APP_ID}&navbar=off&forceUCI=1&pagetype=entityrecord&etn=opportunity&id=${id}&formid=${process.env.REACT_APP_OPP_NAME_URL_FORM_ID}`;
      setSelectedOpportunityId(id); // to store the id
      setPlIframeModalRecoil(true);
    }
  };

  const onCommentIconClick = id => {
    if (
      localStorage.getItem('isSuperUser') == 'true' &&
      localStorage.getItem('targetUserEmail') != 'null'
    ) {
      // Set flag to use userEmail for iframe operations in super user mode for comment header in PL
      localStorage.setItem('isIframeOperation', 'true');
      CommentIframeUrl = `${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_OPP_NAME_URL_APP_ID}&navbar=off&forceUCI=1&pagetype=entityrecord&etn=opportunity&id=${id}&formid=${process.env.REACT_APP_COMMENT_URL_FORM_ID}`;
      MobileCommentIframeUrl = `${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_MOBILE_OPP_NAME_URL_APP_ID}&navbar=off&forceUCI=1&pagetype=entityrecord&etn=opportunity&id=${id}&formid=${process.env.REACT_APP_COMMENT_URL_FORM_ID}`;
      setSelectedCommentOpportunityId(id); // Store the comment opportunity id
      setCommentIframeModalRecoil(true);
    } else {
      // Regular user operation
      localStorage.setItem('isIframeOperation', 'false');
      CommentIframeUrl = `${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_OPP_NAME_URL_APP_ID}&navbar=off&forceUCI=1&pagetype=entityrecord&etn=opportunity&id=${id}&formid=${process.env.REACT_APP_COMMENT_URL_FORM_ID}`;
      MobileCommentIframeUrl = `${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_MOBILE_OPP_NAME_URL_APP_ID}&navbar=off&forceUCI=1&pagetype=entityrecord&etn=opportunity&id=${id}&formid=${process.env.REACT_APP_COMMENT_URL_FORM_ID}`;
      setSelectedCommentOpportunityId(id); // Store the comment opportunity id
      setCommentIframeModalRecoil(true);
    }
  };

  const handleEmptyForecastSubmit = async () => {
    const isSystemTimePassed = hasSystemTimePassed(personaCloseDateCheck);
    if (isSystemTimePassed) {
      setShowSubmissionFailureModal(true);
    } else {
      if (!quarterData) {
        return;
      }

      const MONTH = quarterData.month;
      const YEAR = quarterData.fiscal_year;
      const QUARTER = quarterData.quarter;

      const snapDates = {
        fiscal_month_startdate: quarterData?.current_month_start_date,
        fiscal_month_enddate: quarterData?.current_month_end_date,
        fiscal_quarter_startdate: quarterData?.quarter_start_date,
        fiscal_quarter_enddate: quarterData?.quarter_end_date,
      };

      const rollingDates = {
        fiscal_month_startdate: quarterData?.quarter_start_date,
        fiscal_month_enddate: quarterData?.quarter_end_date,
      };

      const REQ_BODY = {
        forecast_table_details: {
          forecast_id: currentUser.email,
        },
        crm_update: [],
        crm_quaterly_response: [],
        snap_dates: snapDates,
        rolling_dates: rollingDates,
        crm_response: [],
        email: currentUser.email,
        role: currentUser.role,
        performing_segment: null,
        month: MONTH,
        year: YEAR,
        quarter: QUARTER,
      };

      JSON.stringify(REQ_BODY);

      try {
        const response = await submitPlOpportunity(REQ_BODY);
        if (response === true) {
          setShowSubmitConfirmationModal(true);
        }
        setPlCommitData({});
      } catch (error) {
        setShowFailureSubmitModal(true);
      }
    }
  };

  const awdTooltipForMobile = awd => {
    let awdTimeStamp = awd;
    let MonthStartDateCheck = quarterData
      ? new Date(quarterData.current_month_start_date)
      : new Date(systemDateTime);
    let TodaysDate = systemDateTime ? new Date(systemDateTime) : new Date();

    awdTimeStamp = adjustOffsetToTimeZone(awd);
    awdTimeStamp = new Date(
      awdTimeStamp.getFullYear(),
      awdTimeStamp.getMonth(),
      awdTimeStamp.getDate(),
    );

    MonthStartDateCheck = new Date(MonthStartDateCheck.toISOString().split('T')[0]);
    MonthStartDateCheck = new Date(
      MonthStartDateCheck.getFullYear(),
      MonthStartDateCheck.getMonth(),
      MonthStartDateCheck.getDate(),
    );

    TodaysDate = new Date(TodaysDate.getFullYear(), TodaysDate.getMonth(), TodaysDate.getDate());

    // Black Color : If awd is less than month start date AND awd is greater or equal to today's date
    if (awdTimeStamp < MonthStartDateCheck && awdTimeStamp >= TodaysDate) {
      return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <MotifTooltip
            id="bottom"
            trigger={<MotifIcon src={actionIcInfo24px} className="CellWarningErrorBlack" />}
            allowHover={true}
            allowClick={true}
            placement="bottom"
            hideCloseButton={true}
          >
            This AWD is in the past month. <br />
            You will need to update the AWD <br />
            in the Opportunity before changing <br />
            the commit status.
          </MotifTooltip>

          <CellWarningErrorBlack>{`${formatAWDDate(awd)}`}</CellWarningErrorBlack>
        </div>
      );
    }
    // Red Color : If awd is less than today's date
    if (awdTimeStamp < TodaysDate) {
      return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <MotifTooltip
            id="bottom"
            trigger={<MotifIcon src={actionIcInfo24px} className="CellWarningError" />}
            allowHover={true}
            allowClick={true}
            placement="bottom"
            hideCloseButton={true}
          >
            Opportunities must have a <br />
            future Anticipated Win Date <br />
            (AWD) before a forecast can be <br />
            submitted. Please update the <br />
            AWD or mark it as a decline or <br />
            lost through the opportunity <br />
            name hyperlink or by visiting <br /> EY CRM.
          </MotifTooltip>

          <CellWarningError>{`${formatAWDDate(awd)}`}</CellWarningError>
        </div>
      );
    }
    return <TableData1C>{`${formatAWDDate(awd)}`}</TableData1C>;
  };

  return (
    <>
      <PLTableContainer className="ag-theme-alpine">
        {!isMobile ? (
          <>
            {isLoading && !opportunitiesLoaded ? null : (
              <>
                {rowData.length === 0 ? (
                  <EmptyForcastContainer>
                    <EmptyForcastText>
                      There are currently no open opportunities with you named as Pursuit Leader.
                    </EmptyForcastText>
                    <MotifButton
                      style={{ width: '220px', height: '36px' }}
                      onClick={handleEmptyForecastSubmit}
                      disabled={IsSubmitDisabled}
                    >
                      Submit Empty Forecast
                    </MotifButton>
                  </EmptyForcastContainer>
                ) : (
                  <AgGridReact
                    firstColumnBorderRight
                    columnDefs={columnDefs(quarterData)}
                    rowData={rowData}
                    onGridReady={handleGridReady}
                    suppressRowClickSelection
                    suppressCellFocus
                    suppressRowHoverHighlight={true}
                    rowClassRules={rowClassRules}
                    onSortChanged={() => gridApi.redrawRows()}
                    components={{
                      agColumnHeader: TableHeader, //for subtext add molecules/dcsp/components/tableHeader.jsx
                      textCellRendererA: TextCellRendererA,
                      textCellRendererB: TextCellRendererB,
                      textCellRendererC: TextCellRendererC,
                      textCellRendererD: TextCellRendererD,
                      textCellRendererE: TextCellRendererE,
                      pursuitTypeCellRenderer: PursuitTypeCellRenderer,
                      textLinkRenderer: TextLinkRenderer,
                      toggleSwicthRenderer: ToggleSwicthRenderer,
                      commentColumnRenderer: CommentColumnRenderer,
                      awd_Field_Rendere: AWD_Field_Rendere,
                    }}
                    alwaysShowHorizontalScroll={true}
                    //  Pagination
                    paginationPageSize={totalPageRows}
                    pagination={true}
                    paginationAutoPageSize={true}
                  />
                )}
              </>
            )}
          </>
        ) : null}

        {showPlIframeModalRecoil ? (
          <PlOpportunityNameModal
            id={selectedOpportunityId}
            urlSource={isMobile ? PlMobileOppsIframeUrl : PlOppsIframeUrl}
          />
        ) : null}

        {showCommentIframeModalRecoil ? (
          <PlCommentModal
            id={selectedCommentOpportunityId}
            urlSource={isMobile ? MobileCommentIframeUrl : CommentIframeUrl}
          />
        ) : null}

        {isMobile ? (
          <>
            {isLoading && !opportunitiesLoaded ? null : (
              <>
                {rowData.length === 0 ? (
                  <EmptyForcastContainer>
                    <EmptyForcastText>
                      There are currently no open opportunities with you named as Pursuit Leader.
                    </EmptyForcastText>
                    <MotifButton
                      style={{ width: '220px', height: '36px' }}
                      onClick={handleEmptyForecastSubmit}
                    >
                      Submit Empty Forecast
                    </MotifButton>
                  </EmptyForcastContainer>
                ) : (
                  <OppsContainer>
                    <OppsListContainer>
                      {rowData.map(item => (
                        <OppsItemContainer key={item.opp_id}>
                          <ToggleContainer>{ToggleSwicthRenderer(item)}</ToggleContainer>
                          <ItemTextContainer>
                            <ItemLinkText
                              onClick={() => {
                                onOpportunityNameClick(item.opportunity_id);
                              }}
                            >
                              {item.opportunity_name
                                ? trimAndAddDots(item.opportunity_name, 68) //68 is length of how much chars will shows
                                : item.opportunity_name}
                            </ItemLinkText>
                            <ItemDetailsText>
                              {item.client_name
                                ? trimAndAddDots(item.client_name, 35) //35 is length of how much chars will shows
                                : item.client_name}
                            </ItemDetailsText>
                            <ItemDetailsText>
                              <> {item.stagecode_name} | </>
                              <>{awdTooltipForMobile(item?.awd)}</>
                              <> | {item.quarter_year}</>
                            </ItemDetailsText>
                          </ItemTextContainer>
                          <ItemTovValueContainer>
                            {formatNumberWithKAndM(item.tov)}
                          </ItemTovValueContainer>
                        </OppsItemContainer>
                      ))}
                    </OppsListContainer>
                  </OppsContainer>
                )}
              </>
            )}
          </>
        ) : null}
      </PLTableContainer>
    </>
  );
};
export default PursuitLeaderTable;
